import { Button } from '@mui/material';
import React from 'react';
import './Fiverr.css'
const Fiverr = () => {
    return (
        <div className="fiverr-container">
            <h1>I'm Available for Freelancer </h1>
            <Button type="submit" variant="outlined" color="success">
            <a href="https://www.fiverr.com/ashraful_islam4" target="_blank">Hire me  </a>
            </Button>
        </div>
    );
};

export default Fiverr;